import TemplateListaResposta from './TemplateListaResposta';

export default TemplateListaResposta;